import executeRequest from "./request.js";
export const get = async (url) => {
    const response = await executeRequest(url, "GET", {});
    return response;
};
